<template>
    <FormWrapper
        v-if="!loading"
        ref="customFormRef"
        :images-model="images"
        :form-model="form"
        :mandatory-fields="mandatoryFields"
        :changes-model="changes"
        :layer-name="layerName"
        :object-id="objectId"
        :project-id="projectId"
        :latitude="latitude"
        :longitude="longitude"
        @update:images-model="
            (e) => {
                images = e;
            }
        "
        @update:value-missing="
            (e) => {
                valueMissing = e;
            }
        "
        @update:form-model="
            (e) => {
                form = e;
            }
        "
        @update:changes-model="
            (e) => {
                changes = e;
            }
        "
    >
        <template #menu_tabs>
            <el-row class="scroll-menu">
                <el-col :span="12">
                    <div
                        @click="selectTab('GENERAL')"
                        class="tabs"
                        :class="{ selectedTab: selectedTab === 'GENERAL' }"
                    >
                        GENERAL
                    </div>
                </el-col>

                <el-col :span="12">
                    <div
                        @click="selectTab('MECANIQUE')"
                        class="tabs"
                        :class="{ selectedTab: selectedTab === 'MECANIQUE' }"
                    >
                        MECANIQUE
                    </div>
                </el-col>
            </el-row>
        </template>
        <template #main_form>
            <el-row>
                <el-col
                    :span="24"
                    v-show="selectedTab === 'GENERAL'"
                >
                    <CustomInput
                        :label="labels.pt_code + ' *'"
                        :class="{ 'text-warning': valueMissing }"
                        :value="form.pt_code"
                        :disabled="true"
                    />
                    <CustomInputSelect
                        :label="labels.statut + ' *'"
                        :class="{ 'text-warning': valueMissing }"
                        :options="options.statut"
                        :value="form.statut"
                        @update:value="
                            (newValue) => saveData('statut', newValue)
                        "
                    />
                    <CustomInput
                        :label="labels.pt_codeext + ' *'"
                        :class="{ 'text-warning': valueMissing }"
                        :value="form.pt_codeext"
                        :disabled="true"
                    />
                    <CustomInput
                        :label="labels.pt_etiquet + ' *'"
                        :class="{ 'text-warning': valueMissing }"
                        :value="form.pt_etiquet"
                        :maxlength="254"
                        @update:value="
                            (newValue) => saveData('pt_etiquet', newValue)
                        "
                    />
                    <CustomInputSelect
                        :label="labels.donnees_metier"
                        :options="options.donnees_metier"
                        :value="form.donnees_metier"
                        @update:value="
                            (newValue) => saveData('donnees_metier', newValue)
                        "
                    />
                    <CustomInput
                        v-show="condition_pt_nd_code()"
                        :label="labels.pt_nd_code"
                        :value="form.pt_nd_code"
                        :maxlength="254"
                        @update:value="
                            (newValue) => saveData('pt_nd_code', newValue)
                        "
                    />
                    <CustomInput
                        v-show="condition_pt_ad_code()"
                        :label="labels.pt_ad_code"
                        :value="form.pt_ad_code"
                        @update:value="
                            (newValue) => saveData('pt_ad_code', newValue)
                        "
                    />
                    <CustomInput
                        v-show="condition_pt_gest_do()"
                        :label="labels.pt_gest_do"
                        :value="form.pt_gest_do"
                        :maxlength="20"
                        @update:value="
                            (newValue) => saveData('pt_gest_do', newValue)
                        "
                    />
                    <CustomInput
                        v-show="condition_pt_prop_do()"
                        :label="labels.pt_prop_do"
                        :value="form.pt_prop_do"
                        @update:value="
                            (newValue) => saveData('pt_prop_do', newValue)
                        "
                    />
                    <CustomInputSelect
                        v-show="condition_pt_prop()"
                        :label="labels.pt_prop"
                        :options="options.pt_prop"
                        :value="form.pt_prop"
                        @update:value="
                            (newValue) => saveData('pt_prop', newValue)
                        "
                    />
                    <CustomInputSelect
                        v-show="condition_pt_gest()"
                        :label="labels.pt_gest"
                        :options="options.pt_gest"
                        :value="form.pt_gest"
                        @update:value="
                            (newValue) => saveData('pt_gest', newValue)
                        "
                    />
                    <CustomInputSelect
                        v-show="condition_pt_user()"
                        :label="labels.pt_user"
                        :options="options.pt_user"
                        :value="form.pt_user"
                        @update:value="
                            (newValue) => saveData('pt_user', newValue)
                        "
                    />
                    <CustomInputSelect
                        v-show="condition_pt_proptyp()"
                        :label="labels.pt_proptyp"
                        :options="options.pt_proptyp"
                        :value="form.pt_proptyp"
                        @update:value="
                            (newValue) => saveData('pt_proptyp', newValue)
                        "
                    />
                    <CustomInputSelect
                        v-show="condition_pt_statut()"
                        :label="labels.pt_statut"
                        :options="options.pt_statut"
                        :value="form.pt_statut"
                        @update:value="
                            (newValue) => saveData('pt_statut', newValue)
                        "
                    />
                    <CustomInputSelect
                        v-show="condition_pt_etat()"
                        :label="labels.pt_etat"
                        :options="options.pt_etat"
                        :value="form.pt_etat"
                        @update:value="
                            (newValue) => saveData('pt_etat', newValue)
                        "
                    />
                    <CustomDatePicker
                        v-show="condition_pt_dateins()"
                        :label="labels.pt_dateins + ' *'"
                        :class="{ 'text-warning': valueMissing }"
                        :value="form.pt_dateins"
                        @update:value="
                            (newValue) => saveData('pt_dateins', newValue)
                        "
                    />
                    <CustomDatePicker
                        v-show="condition_pt_datemes()"
                        :label="labels.pt_datemes + ' *'"
                        :class="{ 'text-warning': valueMissing }"
                        :value="form.pt_datemes"
                        @update:value="
                            (newValue) => saveData('pt_datemes', newValue)
                        "
                    />
                    <CustomInputSelect
                        v-show="condition_pt_avct()"
                        :label="labels.pt_avct"
                        :options="options.pt_avct"
                        :value="form.pt_avct"
                        @update:value="
                            (newValue) => saveData('pt_avct', newValue)
                        "
                    />
                    <CustomInputSelect
                        v-show="condition_pt_typephy()"
                        :label="labels.pt_typephy + ' *'"
                        :class="{ 'text-warning': valueMissing }"
                        :options="options.pt_typephy"
                        :value="form.pt_typephy"
                        :disabled="true"
                    />
                    <CustomInputSelect
                        v-show="condition_pt_typelog()"
                        :label="labels.pt_typelog"
                        :options="options.pt_typelog"
                        :value="form.pt_typelog"
                        @update:value="
                            (newValue) => saveData('pt_typelog', newValue)
                        "
                    />
                    <CustomInput
                        v-show="condition_pt_rf_code()"
                        :label="labels.pt_rf_code"
                        :value="form.pt_rf_code"
                        @update:value="
                            (newValue) => saveData('pt_rf_code', newValue)
                        "
                    />
                    <CustomInputSelect
                        v-show="condition_pt_nature()"
                        :label="labels.pt_nature"
                        :options="options.pt_nature"
                        :value="form.pt_nature"
                        @update:value="
                            (newValue) => saveData('pt_nature', newValue)
                        "
                    />
                    <CustomInputSwitch
                        v-show="condition_pt_secu()"
                        :label="labels.pt_secu"
                        :options="options.pt_secu"
                        :value="form.pt_secu"
                        @update:value="
                            (newValue) => saveData('pt_secu', newValue)
                        "
                    />
                    <CustomInputSelect
                        v-show="condition_pt_occp()"
                        :label="labels.pt_occp"
                        :options="options.pt_occp"
                        :value="form.pt_occp"
                        @update:value="
                            (newValue) => saveData('pt_occp', newValue)
                        "
                    />
                    <InputNumber
                        v-show="condition_pt_a_dan()"
                        :label="labels.pt_a_dan"
                        :value="form.pt_a_dan"
                        @update:value="
                            (newValue) => saveData('pt_a_dan', newValue)
                        "
                    />
                    <CustomDatePicker
                        v-show="condition_pt_a_dtetu()"
                        :label="labels.pt_a_dtetu"
                        :value="form.pt_a_dtetu"
                        @update:value="
                            (newValue) => saveData('pt_a_dtetu', newValue)
                        "
                    />
                    <CustomInput
                        v-show="condition_pt_a_struc()"
                        :label="labels.pt_a_struc"
                        :value="form.pt_a_struc"
                        :maxlength="100"
                        @update:value="
                            (newValue) => saveData('pt_a_struc', newValue)
                        "
                    />
                    <InputNumber
                        v-show="condition_pt_a_haut()"
                        :label="labels.pt_a_haut"
                        :value="form.pt_a_haut"
                        @update:value="
                            (newValue) => saveData('pt_a_haut', newValue)
                        "
                    />
                    <CustomInputSwitch
                        v-show="condition_pt_a_passa()"
                        :label="labels.pt_a_passa"
                        :options="options.pt_a_passa"
                        :value="form.pt_a_passa"
                        @update:value="
                            (newValue) => saveData('pt_a_passa', newValue)
                        "
                    />
                    <CustomInputSwitch
                        v-show="condition_pt_a_strat()"
                        :label="labels.pt_a_strat"
                        :options="options.pt_a_strat"
                        :value="form.pt_a_strat"
                        @update:value="
                            (newValue) => saveData('pt_a_strat', newValue)
                        "
                    />
                    <InputNumber
                        v-show="condition_pt_rotatio()"
                        :label="labels.pt_rotatio"
                        :value="form.pt_rotatio"
                        @update:value="
                            (newValue) => saveData('pt_rotatio', newValue)
                        "
                    />
                    <CustomInputSwitch
                        v-show="condition_pt_detec()"
                        :label="labels.pt_detec"
                        :options="options.pt_detec"
                        :value="form.pt_detec"
                        @update:value="
                            (newValue) => saveData('pt_detec', newValue)
                        "
                    />
                    <CustomInput
                        v-show="condition_pt_comment()"
                        :label="labels.pt_comment"
                        :value="form.pt_comment"
                        :maxlength="254"
                        @update:value="
                            (newValue) => saveData('pt_comment', newValue)
                        "
                    />
                    <CustomDatePicker
                        v-show="condition_pt_creadat()"
                        :label="labels.pt_creadat + ' *'"
                        :class="{ 'text-warning': valueMissing }"
                        :value="form.pt_creadat"
                        @update:value="
                            (newValue) => saveData('pt_creadat', newValue)
                        "
                    />
                    <CustomDatePicker
                        v-show="condition_pt_majdate()"
                        :label="labels.pt_majdate"
                        :value="form.pt_majdate"
                        @update:value="
                            (newValue) => saveData('pt_majdate', newValue)
                        "
                    />
                    <CustomInput
                        v-show="condition_pt_majsrc()"
                        :label="labels.pt_majsrc"
                        :value="form.pt_majsrc"
                        :maxlength="254"
                        @update:value="
                            (newValue) => saveData('pt_majsrc', newValue)
                        "
                    />
                    <CustomDatePicker
                        v-show="condition_pt_abddate()"
                        :label="labels.pt_abddate"
                        :value="form.pt_abddate"
                        @update:value="
                            (newValue) => saveData('pt_abddate', newValue)
                        "
                    />
                    <CustomInput
                        v-show="condition_pt_abdsrc()"
                        :label="labels.pt_abdsrc"
                        :value="form.pt_abdsrc"
                        :maxlength="254"
                        @update:value="
                            (newValue) => saveData('pt_abdsrc', newValue)
                        "
                    />
                </el-col>
                <el-col
                    :span="24"
                    v-show="selectedTab === 'MECANIQUE'"
                >
                    <CustomRadioButton
                        :label="labels.fixation_du_des_cables_s_1"
                        :options="options.fixation_du_des_cables_s_1"
                        :value="form.fixation_du_des_cables_s_1"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData('fixation_du_des_cables_s_1', newValue)
                        "
                    />

                    <div v-show="condition_img_fixation_du_des_cables_s_1()">
                        <InputCamera
                            :label="labels.img_fixation_du_des_cables_s_1"
                            :images="images.img_fixation_du_des_cables_s_1"
                            :layer-name="layerName"
                            @update:images="
                                (newValue) =>
                                    saveImage(
                                        'img_fixation_du_des_cables_s_1',
                                        newValue,
                                    )
                            "
                        />
                    </div>
                    <CustomInput
                        v-show="
                            condition_commentaire_fixation_du_des_cables_s_1()
                        "
                        :label="labels.commentaire_fixation_du_des_cables_s_1"
                        :value="form.commentaire_fixation_du_des_cables_s_1"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_fixation_du_des_cables_s_1',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.obturation_des_alveoles_fou"
                        :options="options.obturation_des_alveoles_fou"
                        :value="form.obturation_des_alveoles_fou"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'obturation_des_alveoles_fou',
                                    newValue,
                                )
                        "
                    />

                    <div v-show="condition_img_obturation_des_alveoles_fou()">
                        <InputCamera
                            :label="labels.img_obturation_des_alveoles_fou"
                            :images="images.img_obturation_des_alveoles_fou"
                            :layer-name="layerName"
                            @update:images="
                                (newValue) =>
                                    saveImage(
                                        'img_obturation_des_alveoles_fou',
                                        newValue,
                                    )
                            "
                        />
                    </div>
                    <CustomInput
                        v-show="
                            condition_commentaire_obturation_des_alveoles_fou()
                        "
                        :label="labels.commentaire_obturation_des_alveoles_fou"
                        :value="form.commentaire_obturation_des_alveoles_fou"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_obturation_des_alveoles_fou',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.passage_dans_l_alveole_adequa"
                        :options="options.passage_dans_l_alveole_adequa"
                        :value="form.passage_dans_l_alveole_adequa"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'passage_dans_l_alveole_adequa',
                                    newValue,
                                )
                        "
                    />

                    <div v-show="condition_img_passage_dans_l_alveole_adequa()">
                        <InputCamera
                            :label="labels.img_passage_dans_l_alveole_adequa"
                            :images="images.img_passage_dans_l_alveole_adequa"
                            :layer-name="layerName"
                            @update:images="
                                (newValue) =>
                                    saveImage(
                                        'img_passage_dans_l_alveole_adequa',
                                        newValue,
                                    )
                            "
                        />
                    </div>
                    <CustomInput
                        v-show="
                            condition_commentaire_passage_dans_l_alveole_adequa()
                        "
                        :label="
                            labels.commentaire_passage_dans_l_alveole_adequa
                        "
                        :value="form.commentaire_passage_dans_l_alveole_adequa"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_passage_dans_l_alveole_adequa',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.passage_cable_s_en_goutte_le"
                        :options="options.passage_cable_s_en_goutte_le"
                        :value="form.passage_cable_s_en_goutte_le"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'passage_cable_s_en_goutte_le',
                                    newValue,
                                )
                        "
                    />

                    <div v-show="condition_img_passage_cable_s_en_goutte_le()">
                        <InputCamera
                            :label="labels.img_passage_cable_s_en_goutte_le"
                            :images="images.img_passage_cable_s_en_goutte_le"
                            :layer-name="layerName"
                            @update:images="
                                (newValue) =>
                                    saveImage(
                                        'img_passage_cable_s_en_goutte_le',
                                        newValue,
                                    )
                            "
                        />
                    </div>
                    <CustomInput
                        v-show="
                            condition_commentaire_passage_cable_s_en_goutte_le()
                        "
                        :label="labels.commentaire_passage_cable_s_en_goutte_le"
                        :value="form.commentaire_passage_cable_s_en_goutte_le"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_passage_cable_s_en_goutte_le',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.gaine_de_protection_cable_s_1"
                        :options="options.gaine_de_protection_cable_s_1"
                        :value="form.gaine_de_protection_cable_s_1"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'gaine_de_protection_cable_s_1',
                                    newValue,
                                )
                        "
                    />

                    <div v-show="condition_img_gaine_de_protection_cable_s_1()">
                        <InputCamera
                            :label="labels.img_gaine_de_protection_cable_s_1"
                            :images="images.img_gaine_de_protection_cable_s_1"
                            :layer-name="layerName"
                            @update:images="
                                (newValue) =>
                                    saveImage(
                                        'img_gaine_de_protection_cable_s_1',
                                        newValue,
                                    )
                            "
                        />
                    </div>
                    <CustomInput
                        v-show="
                            condition_commentaire_gaine_de_protection_cable_s_1()
                        "
                        :label="
                            labels.commentaire_gaine_de_protection_cable_s_1
                        "
                        :value="form.commentaire_gaine_de_protection_cable_s_1"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_gaine_de_protection_cable_s_1',
                                    newValue,
                                )
                        "
                    />
                    <CustomInputSelect
                        :label="labels.autres_observations"
                        :options="options.autres_observations"
                        :value="form.autres_observations"
                        @update:value="
                            (newValue) =>
                                saveData('autres_observations', newValue)
                        "
                    />

                    <div v-show="condition_img_autres_observations()">
                        <InputCamera
                            :label="labels.img_autres_observations"
                            :images="images.img_autres_observations"
                            :layer-name="layerName"
                            @update:images="
                                (newValue) =>
                                    saveImage(
                                        'img_autres_observations',
                                        newValue,
                                    )
                            "
                        />
                    </div>
                    <CustomInput
                        v-show="condition_commentaire_autres_observations()"
                        :label="labels.commentaire_autres_observations"
                        :value="form.commentaire_autres_observations"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_autres_observations',
                                    newValue,
                                )
                        "
                    />
                </el-col>
            </el-row>
        </template>
    </FormWrapper>
</template>

<script lang="ts">
/* eslint-disable */
import { defineComponent } from 'vue';

import type { FormDataInterface } from '@connect-field/client/components/forms/form.types';
import FormTemplate from '@connect-field/client/components/forms/FormTemplate.vue';

import {
    labels,
    options,
} from '@connect-field/client/components/forms/DrivOptic/form_audit_chambre_passage_drivoptic.data';

interface DataInterface extends FormDataInterface {}

export default defineComponent({
    extends: FormTemplate,
    data(): DataInterface {
        return {
            changes: false,
            form: {},
            images: {
                img_fixation_du_des_cables_s_1: [],
                img_obturation_des_alveoles_fou: [],
                img_passage_dans_l_alveole_adequa: [],
                img_passage_cable_s_en_goutte_le: [],
                img_gaine_de_protection_cable_s_1: [],
                img_autres_observations: [],
            },
            labels,
            loading: true,
            mandatoryFields: [
                'pt_code',
                'statut',
                'pt_codeext',
                'pt_etiquet',
                'pt_dateins',
                'pt_datemes',
                'pt_typephy',
                'pt_creadat',
            ],
            options,
            selectedTab: 'GENERAL',
            valueMissing: false,
        };
    },
    methods: {
        condition_pt_nd_code(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_ad_code(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_gest_do(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_prop_do(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_prop(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_gest(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_user(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_proptyp(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_statut(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_etat(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_dateins(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_datemes(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_avct(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_typephy(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_typelog(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_rf_code(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_nature(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_secu(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_occp(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_a_dan(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_a_dtetu(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_a_struc(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_a_haut(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_a_passa(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_a_strat(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_rotatio(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_detec(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_comment(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_creadat(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_majdate(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_majsrc(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_abddate(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_pt_abdsrc(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === 'OUI';
        },
        condition_img_fixation_du_des_cables_s_1(): boolean {
            const { fixation_du_des_cables_s_1 } = this.form;
            return fixation_du_des_cables_s_1?.startsWith('NOK');
        },
        condition_commentaire_fixation_du_des_cables_s_1(): boolean {
            const { fixation_du_des_cables_s_1 } = this.form;
            return fixation_du_des_cables_s_1?.startsWith('NOK');
        },
        condition_img_obturation_des_alveoles_fou(): boolean {
            const { obturation_des_alveoles_fou } = this.form;
            return obturation_des_alveoles_fou?.startsWith('NOK');
        },
        condition_commentaire_obturation_des_alveoles_fou(): boolean {
            const { obturation_des_alveoles_fou } = this.form;
            return obturation_des_alveoles_fou?.startsWith('NOK');
        },
        condition_img_passage_dans_l_alveole_adequa(): boolean {
            const { passage_dans_l_alveole_adequa } = this.form;
            return passage_dans_l_alveole_adequa?.startsWith('NOK');
        },
        condition_commentaire_passage_dans_l_alveole_adequa(): boolean {
            const { passage_dans_l_alveole_adequa } = this.form;
            return passage_dans_l_alveole_adequa?.startsWith('NOK');
        },
        condition_img_passage_cable_s_en_goutte_le(): boolean {
            const { passage_cable_s_en_goutte_le } = this.form;
            return passage_cable_s_en_goutte_le?.startsWith('NOK');
        },
        condition_commentaire_passage_cable_s_en_goutte_le(): boolean {
            const { passage_cable_s_en_goutte_le } = this.form;
            return passage_cable_s_en_goutte_le?.startsWith('NOK');
        },
        condition_img_gaine_de_protection_cable_s_1(): boolean {
            const { gaine_de_protection_cable_s_1 } = this.form;
            return gaine_de_protection_cable_s_1?.startsWith('NOK');
        },
        condition_commentaire_gaine_de_protection_cable_s_1(): boolean {
            const { gaine_de_protection_cable_s_1 } = this.form;
            return gaine_de_protection_cable_s_1?.startsWith('NOK');
        },
        condition_img_autres_observations(): boolean {
            const { autres_observations } = this.form;
            return autres_observations === 'OUI';
        },
        condition_commentaire_autres_observations(): boolean {
            const { autres_observations } = this.form;
            return autres_observations === 'OUI';
        },
    },
});
</script>
